(function($){

$(document).ready(function() {  
function openchat() {
  $('#zowieFloatingButton').click();
} 
$( "#nl-promo" ).click(function() {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Xh6uBq']);
});
$( ".nl-promo" ).click(function() {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Xh6uBq']);
});  
});  
$( "#workplace" ).hover(function() {
	$imgURL = "https://cdn.shopify.com/s/files/1/0557/8014/7381/files/workplace-nav.jpg?v=1667852241";
        $(".dropnav1 .widget-img-container img").attr("src",$imgURL);
});
$( "#fitness" ).hover(function() {
	$imgURL = "https://cdn.shopify.com/s/files/1/0557/8014/7381/files/fitness.jpg?v=1667403707";
        $(".dropnav1 .widget-img-container img").attr("src",$imgURL);
});
$( "#sale" ).hover(function() {
	$imgURL = "https://cdn.shopify.com/s/files/1/0557/8014/7381/files/Menu_Image_320x320_110d9802-287a-4488-8b0d-f05cbf2eb477.jpg?v=1698876472";
        $(".dropnav1 .widget-img-container img").attr("src",$imgURL);
}); 
$( "#can-nlsign" ).click(function() {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Xh6uBq']);
});
  
 
$( "#group_select li" ).click(function() {
    $( "#group_select li" ).removeClass('active');
	$(this).addClass('active');
    var currentval = $(this).data('groups');
  console.log(currentval);
    if (currentval == "Fitness") {$(".Workplace").slideUp("slow");$(".Fitness").slideDown("slow");$(".open-box").slideDown("slow");}
  if (currentval == "Workplace") {$(".Workplace").slideDown("slow");$(".Fitness").slideUp("slow");$(".open-box").slideUp("slow");}
  if (currentval == "clearance") {$(".Workplace").slideUp("slow");$(".Fitness").slideUp("slow");$(".clearance").slideDown("slow");}
  if (currentval == "special") {$(".Workplace").slideUp("slow");$(".Fitness").slideUp("slow");$(".open-box").slideUp("slow");$(".special").slideDown("slow");}
  if (currentval == "view_all") {$(".Workplace").slideDown("slow");$(".Fitness").slideDown("slow");}
});
  
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
var group =  getUrlParameter('group');
if (group) {
    var currentval = group;
    if (currentval == "Fitness") {$(".Workplace").slideUp("slow");$(".Fitness").slideDown("slow");$(".open-box").slideDown("slow");$("[data-groups='Fitness']").addClass('active');}
  if (currentval == "Workplace") {$(".Workplace").slideDown("slow");$(".Fitness").slideUp("slow");$(".open-box").slideUp("slow");$("[data-groups='Workplace']").addClass('active');}
  if (currentval == "clearance") {$(".Workplace").slideUp("slow");$(".Fitness").slideUp("slow");$(".clearance").slideDown("slow");$("[data-groups='clearance']").addClass('active');}
  if (currentval == "special") {$(".Workplace").slideUp("slow");$(".Fitness").slideUp("slow");$(".open-box").slideUp("slow");$(".special").slideDown("slow");$("[data-groups='special']").addClass('active');}
  if (currentval == "view_all") {$(".Workplace").slideDown("slow");$(".Fitness").slideDown("slow");}
}

  
   $( "#kldiscpop" ).on( "click", function() {
  window._klOnsite = window._klOnsite || [];
window._klOnsite.push(['openForm', 'Wmh4vb']);
});

    $('#shopify-section-treadmill_config').on('click','#o_14645 .mw-option__button',function(){
//      console.log('clicked');
      $("#customize-your-own .product-form__controls-group").css('display','block');
    }); 
  $("#homepage .recently-viewed").prependTo("#s-70db7ccc-ebd6-4e40-9ed2-2938485222d8");
// HubSpot Start  
  $('#s-9fb49279-2baa-404e-bf95-2b4615ad8ac0').on('click', (e) => {
    e.preventDefault();
    GorgiasChat.open();
  });
  
  $('#s-508d31bb-5746-4245-b8fe-824f97d32901').on('click', (e) => {
    e.preventDefault();
    GorgiasChat.open();
  });
  
  $(document).ready(function() {
    var console_option = $('.rio-product-option-title-option-value').text();
    if (console_option){
      if (console_option == 'Retro'){$('#retro').show();} else {$('#omni').show();}
    }
    
    //add click
     $('.PwzrGrid-root.PwzrGrid-container').on('click', () => {
    var console_option = $('.rio-product-option-title-option-value').text();
    console.log(console_option);
    $('.console-sl-option').hide();
    if (console_option == 'Retro'){$('#retro').show();} else {$('#omni').show();}
  });
  });

$( "#sales_select" ).change(function() {
  var currentval = $(this).val();
  if (currentval == "Fitness") {$(".Workplace").slideUp("slow");$(".Fitness").slideDown("slow");}
  if (currentval == "Workplace") {$(".Workplace").slideDown("slow");$(".Fitness").slideUp("slow");}
  if (currentval == "open-box") {$(".Workplace").slideUp("slow");$(".Fitness").slideUp("slow");$(".open-box").slideDown("slow");}
  if (currentval == "closeout") {$(".Workplace").slideUp("slow");$(".Fitness").slideUp("slow");$(".closeout").slideDown("slow");}
  if (currentval == "view_all") {$(".Workplace").slideDown("slow");$(".Fitness").slideDown("slow");}
});  
/* 
var number = 1;
 setInterval(function () {
   $(".desktop-hero.banner-swap").fadeOut(function() {
     if (number % 2 == 1) { $( ".desktop-hero.banner-swap" ).text( "12 Days of Fitmas Happening Now! - Best price of the year").fadeIn(); }
   if (number % 2 == 0) { $( ".desktop-hero.banner-swap" ).text( 'Check "Special Deals" for Holiday Sales!').fadeIn(); }
   });
   number ++
   console.log(number);
},4000);  
 */ 
// Hubspot Stop
  
  $( ".desk-compare-toggle" ).on( "click", function() {
    var id = $(this).attr('data-location');
//    console.log(id);
    $(".desk-compare-block-"+id).slideToggle(1300, function(){
      if($(this).is(":visible")){
        console.log('opening');
        $(".desk-compare-text."+id).fadeOut(function() {
          console.log(id);
          $(this).text('CLOSE COMPARE').fadeIn();
          $('[data-location="'+id+'"] i').addClass("fa-chevron-circle-up", {duration:3000});
        });
        
      }
      else {
        console.log('closing');
        $(".desk-compare-text."+id).fadeOut(function() {
          var cat_text = id.replace(/-/g, ' ');
          console.log(cat_text);
          $(this).text('COMPARE '+cat_text+' TREADMILLS').fadeIn();
          $('[data-location="'+id+'"] i').removeClass("fa-chevron-circle-up", {duration:3000});
        });
        
      }
    });
  });
  


  var PDPState = 0;
  var Warrantypage = "";
  var TabChange = "";
  let selectedWarranty
  let pdpInline
  let pdpModal
  function removeAndSync() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (cart) {

    });
  }
  
  function PDPChangeState(){
    var index = PDPState;
    index++;
//    alert(index);
    var target = $('#tab'+index);
    if (!target.hasClass('is-current')){
      var tempTarget = $('.product__tab.is-current');
      tempTarget.fadeOut(400,function(){
        tempTarget.removeClass('is-current');
        target.fadeIn(400, function(){
          target.addClass('is-current');
        });
      });
    }
      $('.product__tabs-nav').find('a').parent().removeClass('is-current');
      $('.product__tabs-nav').find('[href="#tab'+index+'"]').parent().removeClass('is-disabled');
      $('.product__tabs-nav').find('[href="#tab'+index+'"]').parent().addClass('is-current');
  }
  
  
  $('#tab1').find('.product__actions .shopify-payment-button__button').on('click', function(e){
    e.preventDefault();
    PDPState = 1;
    PDPChangeState()
  });
  $('#tab2').find('.product__actions .shopify-payment-button__button').on('click', function(e){
    e.preventDefault();
    CheckoutWithOptions();
  });
  $('#canada').find('.shopify-payment-button__button').on('click', function(e){
    e.preventDefault();
    CheckoutWithOptions();
  });

  $('.previous-step').on('click', function(e){
    e.preventDefault();
    PDPState = PDPState - 1;
    PDPChangeState()
  });
  
  $('[href="#tab1"]').on('click', function(e){
    
    if(!$(this).parent().hasClass('is-disabled')){
      e.preventDefault();
      PDPState = 0;
      PDPChangeState();
    }
  });  
  $('[href="#tab2"]').on('click', function(e){
    
    if(!$(this).parent().hasClass('is-disabled')){
      e.preventDefault();
      PDPState = 1;
      PDPChangeState();
    }
  });  
    async function CheckoutWithOptions(skip){
 
      console.log('checkoutwithoptions');
      var WgdCode = '39972211065013';
      var ThCode = '39972210704565';
      var RocCode = '39972210966709';
      var StdCode = '42721565606069';
      var shipopt = $('input[name=ship_option]:checked').val();
      var pronote = $('input[name=ship_option]:checked').data("product-name");
//      alert(shipopt);
      
    	if ($("select[name='id']").val()) {
            var TreadCode = $("select[name='id']").val();
        } else {
            var TreadCode = variantLibrary[0].id;
        }
//        console.log(TreadCode);
    	TreadName = variantLibrary[0].title;
//      	alert(TreadCode);
      if (shipopt == 'threshold') {
        var objArray = [
          {
              id: ThCode,
              properties: {'For': pronote},
              quantity: 1
            },
          {
              id: TreadCode,
              quantity: 1
            }
          ];
      }
      else if (shipopt == 'standard') {
        var objArray = [
          {
              id: StdCode,
              properties: {'For': pronote},
              quantity: 1
            },
          {
              id: TreadCode,
              quantity: 1
            }
          ];
      }  
      else if (shipopt == 'roomofchoice') {
        var objArray = [
          {
              id: RocCode,
              properties: {'For': pronote},
              quantity: 1
            },
          {
              id: TreadCode,
              quantity: 1
            }
          ];
      }
      else if (shipopt == 'whiteglove') {
        var objArray = [
          {
              id: WgdCode,
              properties: {'For': pronote},
              quantity: 1
            },
          {
              id: TreadCode,
              quantity: 1
            }
          ];
      }
      else {
        var objArray = [
          {
              id: TreadCode,
              quantity: 1
            }
          ];
      }
      console.log(objArray);

//         CartJS.addItems(objArray, {
//             "success": function(data, textStatus, jqXHR) {
//                 console.log('Added');
//                 window.location = '/cart';
//             },
//             "error": function(jqXHR, textStatus, errorThrown) {
//                 console.log('Error: ' + errorThrown + '!');
//             }
//         });
       var payload = {
         items: objArray,
       }

       fetch('/cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(payload),
        })
       .then(res => {
           console.log('Added');
           window.location = '/cart';
         }
        )
       .catch(err => {console.log('Error: ' + err + '!')});

    }
  
  
    $(window).scroll(function() {
      if($("#breadcrumb").length != 0) {
        var HeaderHeight = $('#shopify-section-header').height();
        var WindowTop = $(window).scrollTop();
        var CrumbsToTop = $('#breadcrumb').offset().top - WindowTop;
        if ((HeaderHeight >= CrumbsToTop) ) {$('.breadcrumbs').addClass('bread-sticky');} else {$('.breadcrumbs').removeClass('bread-sticky');}
      }
      
      if($("#s-835b4ddd-09f2-404b-975d-8417e2440fe2").length != 0) {
      var distanceFromTop = $(this).scrollTop();
      //    console.log(distanceFromTop);
      //    console.log('header '+$('header').height());
      var descriptionscr = ($('#s-835b4ddd-09f2-404b-975d-8417e2440fe2').offset().top - distanceFromTop);
      var featurescr = ($('#s-25ce9b01-680c-4445-b948-0fa071d37432').offset().top - distanceFromTop);
      var reviewcr = ($('#s-bd8623b5-5120-40f0-9bf3-f83d80b8be20').offset().top - distanceFromTop);
      var financescr = ($('#s-78c87354-9248-4d84-8177-87e0b4212eea').offset().top - distanceFromTop);
      //	console.log(financescr);
      $('.nav-tab').css({'text-decoration':'none','font-weight':'400'});
      switch (true) {
        case (financescr <= 5):
          $('#shop-treadmill-desk-nav .nav-tab:nth-child(4)').css({'text-decoration':'underline','font-weight':'700'});
          break;
        case (reviewcr <= 5):
          $('.nav-tab').css('text-decoration','none');
          $('#shop-treadmill-desk-nav .nav-tab:nth-child(3)').css({'text-decoration':'underline','font-weight':'700'});
          break;
        case (featurescr <= 5):
          $('.nav-tab').css('text-decoration','none');
          $('#shop-treadmill-desk-nav .nav-tab:nth-child(2)').css({'text-decoration':'underline','font-weight':'700'});
          break;
        case (descriptionscr <= 5):
          $('#shop-treadmill-desk-nav .nav-tab:nth-child(1)').css({'text-decoration':'underline','font-weight':'700'});
          break;
        default:
          $('.nav-tab').css({'text-decoration':'none','font-weight':'400'});
      }

      if (distanceFromTop >= $('#s-68ed0457-d53a-4077-92fd-7bcd2036c36e').height() + 140) {
        $('.sticky').addClass('fixed');

      } else {
        $('.sticky').removeClass('fixed');
      }
        }
    });
  
  
  
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });

$('.ship-selection-block').removeClass( "active");
$('input[type=radio][name=ship_option]:checked').closest( "li" ).addClass( "active");
$('input[type=radio][name=ship_option]').change(function() {
  $('.ship-selection-block').removeClass( "active");
  $(this).closest( "li" ).addClass( "active");
});

$( ".make-desk-link" ).mousedown(function() {
  clearInterval(refreshId);
});
  $('#make-desk .make-desk-link').on('click', function(){
//    clearInterval(refreshId);
    $("#make-desk.make-desk-grid li").css('opacity','.6');
    $("#make-desk .make-desk-detail").slideUp();
    $("#make-desk .make-desk-link").removeClass('active');
    $('#make-desk .make-desk-link').css('font-weight','400');
    $(this).parent().css('opacity','1');
    $(this).next().slideDown();
    $(this).css('font-weight','700',).addClass('active');
  });
  $('#design-desk .make-desk-link').on('click', function(){
    $("#design-desk.make-desk-grid li").css('opacity','.6');
    $("#design-desk .make-desk-detail").slideUp();
    $("#design-desk .make-desk-link").removeClass('active');
    $('#design-desk .make-desk-link').css('font-weight','400');
    $(this).parent().css('opacity','1');
    $(this).next().slideDown();
    $(this).css('font-weight','700',).addClass('active');
  });
  
  var i = 0;
  var refreshId = setInterval(function() {
    var properID;
//    console.log(i);
    i++;
    $('#make-desk li:nth-child('+i+') .make-desk-link').click();
    $('#design-desk li:nth-child('+i+') .make-desk-link').click();
    if (i==3){i = 0;}

  }, 5000);

 $('#cstm-nws-btn').on("click", function(){
  $('p.error, p.success').remove();
  if($("#custm-news-email").val() !== ''){
    var data = $("#cstm-nws").serialize();
    $.ajax({  
      type: "POST",  
      url: "/contact",  
      data: data,  
      success: function() { 
        $('#cstm-nws').append('<p class="success">Thank You!</p>');
      },
      error: function() {
        $('#cstm-nws').append('<p class="errror">There was an error in submitting the form.</p>');
      }    
    }); 
  }
  else {
    $("#cstm-nws").append('<p class="error">Please fill in your email address.</p>');  
  }
  return false;
});

$("#custm-news-email").on('keypress',function(e) {
    if(e.which == 13) {
        $('#cstm-nws-btn').trigger("click");
    }
});

(function() {
  const targetNode = document.querySelector('.bread-with-options');
  if (targetNode){
  const config = { childList: true, subtree: true, characterData: true };

  const callback = function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const element = document.querySelector('[data-testid="bread-placement-bread-checkout-btn-product"][data-placement-i-d="bread-checkout-btn-product"]');

        if (element && element.textContent.includes('As low')) {
          element.textContent = 'Prequalify Now';
          console.log('Text successfully changed.');
          $(".product__price.bread-section").show();
          $('#product-finance-block').on('click', function(e){
          	const targetclicko = document.querySelector('#bread-checkout-btn-product a');
          	targetclicko.dispatchEvent(new Event('click'));
          });
          $('.bread-finance-banner').on('click', function(e){
          	const targetclicko = document.querySelector('#bread-checkout-btn-product a');
          	targetclicko.dispatchEvent(new Event('click'));
          });
          $("#bread-checkout-btns").html("View More");
          $(".header__financing").show();
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
  }
 
})();
  
})(jQuery);

(function (window, document) { 
   var __close_message__ = "__PROGRESSIVE_UI_CLOSE__"; 
   window.ProgHangtag = window.ProgHangtag || {}; 
   var ProgHangtag = window.ProgHangtag; 
   ProgHangtag.CloseApplicationUI = function () { 
       window.postMessage(__close_message__, "*"); 
   }; 
   ProgHangtag.OpenPaymentEstimator = function (storeId, stateCode, itemCost, requestType, placement) { 
       document.body.style.overflow = "hidden"; 
       var mobileViewThreshold = 1024; 
       var url = "https://progressivelp.com/eComUI/#/apply/est-settings?storeId=" + storeId + "&itemCost=" + itemCost + "&requestType=" + requestType + "&isFinanceIntegrated=false&customOfferCode=&approveMeName=lifespanfitness&approveMeSlugValue=105738"; 
       if (stateCode != null) 
           url = url + "&stateCode=" + stateCode; 
       var backdrop = document.createElement("div"); 
       var iframe = document.createElement("iframe"); 
       backdrop.id = "progressive-backdrop"; 
       backdrop.zIndex = "1677727"; 
       iframe.zIndex = "1677728"; 
       iframe.src = url; 
       backdrop.style.opacity = 0; 
       iframe.style.opacity = 0; 
       backdrop.style.transition = "all 300ms"; 
       iframe.style.transition = "all 300ms"; 
       iframe.style.backgroundColor = "#FFFFFF"; 
       iframe.style.zIndex = "1677728"; 
       backdrop.style.zIndex = "1677727"; 
       function isMobile() { 
           return window.innerWidth < mobileViewThreshold; 
       } 
       function setMobileStyles() { 
           backdrop.style.position = 'fixed'; 
           backdrop.style.top = 0; 
           backdrop.style.left = 0; 
           backdrop.style.bottom = 0; 
           backdrop.style.right = 0; 
           backdrop.style.background = "#000000"; 
           iframe.style.position = "fixed"; 
           iframe.style.display = "block"; 
           iframe.style.left = 0; 
           iframe.style.top = 0; 
           iframe.style.right = 0; 
           iframe.style.bottom = 0; 
           iframe.style.width = "100%"; 
           iframe.style.height = "100%"; 
           iframe.style.marginLeft = "0px"; 
           iframe.style.marginTop = "0px"; 
           iframe.style.borderRadius = "0px"; 
           iframe.style.border = "none"; 
       } 
       function setDesktopStyles() { 
           backdrop.style.position = "fixed"; 
           backdrop.style.top = 0; 
           backdrop.style.left = 0; 
           backdrop.style.bottom = 0; 
           backdrop.style.right = 0; 
           iframe.style.width = "500px"; 
           iframe.style.maxHeight = "686px"; 
           iframe.style.height = "calc(100vh - 80px - 5%)"; 
           iframe.style.position = "fixed"; 
           if (placement === "right") { 
               iframe.style.right = "8px"; 
               iframe.style.bottom = 0; 
               iframe.style.boxShadow = "-1px -1px 0 0 rgb(223, 227, 232)"; 
           } else { // style for center placement 
               backdrop.style.background = "#000000"; 
               iframe.style.top = "80px"; 
               iframe.style.left = "50%"; 
               iframe.style.marginLeft = "-250px"; 
               iframe.style.marginTop = "3%"; 
           } 
           iframe.style.border = "1px solid rgb(223, 227, 232)"; 
       } 
       function animateIn() { 
           body.appendChild(backdrop); 
           body.appendChild(iframe); 
           setTimeout(function () { 
               backdrop.style.opacity = 0.5; 
               setTimeout(function () { 
                   iframe.style.opacity = 1; 
               }, 200); 
           }, 1);  
       } 
       function animateOut() { 
           iframe.style.opacity = 0; 
           backdrop.style.opacity = 0; 
           setTimeout(function() { 
                   document.body.removeChild(iframe); 
                   document.body.removeChild(backdrop); 
                   document.body.style.overflow = null; 
               }, 
               300); 
       } 
       function updateStyles() { 
           window.innerWidth >= mobileViewThreshold ? setDesktopStyles() : setMobileStyles(); 
       } 
       window.addEventListener('resize', updateStyles); 
       var body = document.body; 
       updateStyles(); 
       animateIn(); 
       function handleFrameMessage(msg) { 
           if (msg.data === __close_message__) { 
               animateOut(); 
               window.removeEventListener('message', handleFrameMessage); 
           } 
       } 
       window.addEventListener('message', handleFrameMessage); 
   }; 
})(window, document)